import mitt from 'mitt';
var emitter = mitt();
var eventHub = {
  $on: function $on() {
    return emitter.on.apply(emitter, arguments);
  },
  $once: function $once() {
    return emitter.once.apply(emitter, arguments);
  },
  $off: function $off() {
    return emitter.off.apply(emitter, arguments);
  },
  $emit: function $emit() {
    return emitter.emit.apply(emitter, arguments);
  }
};
export default eventHub;